<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="danger" v-b-tooltip.hover :title="showToolTip ? 'Поместить в корзину' : ''"><i class="fa fa-trash"></i></b-button>
  <!--<b-button @click="$emit('click')" size="sm" variant="primary" v-b-tooltip.hover :title="showToolTip ? 'Поместить в корзину' : ''"><i class="fa fa-trash-0"></i></b-button>-->
</template>

<script>

export default ({
  name: "button-trash",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  },
})
</script>
